module.exports = __webpack_public_path__ + "media/images/marker-shadow-44a526eed258222515aa21eaffd14a96.png";